// extracted by mini-css-extract-plugin
export var wrapper = "Value-module--wrapper--21Vku";
export var itemGrid = "Value-module--item-grid--JdS5S";
export var item = "Value-module--item--1UVrS";
export var label = "Value-module--label--2Ad2z";